import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Drawer, message } from "antd";
import { MenuOutlined } from "@ant-design/icons";

export default function Navbar({
  user,
  setLoginOpen,
  setRegisterOpen,
  setFaqOpen,
  setPricingOpen,
  setMyAccountOpen,
  handleLogout
}) {
  const [showAccount, setShowAccount] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Shared classes for consistency
  const baseBtnStyle = "px-5 py-2 rounded-md text-[15px] font-medium transition-all duration-200 ease-in-out hover:scale-[1.03] active:scale-[0.97] cursor-pointer";
  const primaryBtnStyle = `${baseBtnStyle} bg-[#1677ff] text-white hover:shadow-md border-none`;
  const secondaryBtnStyle = `${baseBtnStyle} bg-white text-[#333] border border-[#00000069] hover:shadow-md`;
  // Removed dangerBtnStyle as it's no longer needed based on your request

  // Menu pour le Drawer mobile
  const menuItems = (
    <div className="flex flex-col gap-4 text-[17px] text-[#333] font-medium">
      <Link to="/c/start" onClick={() => setOpen(false)}>CiviChat</Link>
      <Link to="/pdf/start" onClick={() => setOpen(false)}>CiviDocs</Link>
      <Link to="/render/start" onClick={() => setOpen(false)}>CiviRender</Link>
      <Link to="/about" onClick={() => setOpen(false)}>About</Link>
      <Link to="/documentation" onClick={() => setOpen(false)}>Libraries</Link>
      <span onClick={() => { setFaqOpen(true); setOpen(false); }}>FAQ</span>
      <Link to="/contact" onClick={() => setOpen(false)}>Contact</Link>
    </div>
  );

  return (
    <nav
      className="w-full bg-white shadow-sm py-2 flex items-center justify-between z-10"
      style={{
        position: "sticky",
        top: 0,
        boxShadow: "0 1px 5px rgba(0, 0, 0, 0.1)",
        zIndex: 50,
        height: "60px",
      }}
    >
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2 px-[8px] py-[4px]">
        <img src="/images/full-logo.png" alt="CiviBOT Logo" className="h-[45px]" />
      </Link>

      {/* --- NAVBAR ORIGINALE PC --- */}
      <div className="hidden md:flex flex-1 justify-center gap-8 items-center text-[17px] text-[#333] font-medium">
        <Link to="/c/start" className="cursor-pointer hover:text-[#1677ff]">CiviChat</Link>
        <Link to="/pdf/start" className="cursor-pointer hover:text-[#1677ff]">CiviDocs</Link>
        <Link to="/render/start" className="cursor-pointer hover:text-[#1677ff]">CiviRender</Link>
        <Link to="/about" className="cursor-pointer hover:text-[#1677ff]">About</Link>
        <Link to="/documentation" className="cursor-pointer hover:text-[#1677ff]">Libraries</Link>
        <span className="cursor-pointer hover:text-[#1677ff]" onClick={() => setFaqOpen(true)}>FAQ</span>
        <Link className="cursor-pointer hover:text-[#1677ff]" to="/contact">Contact</Link>
      </div>

      {/* Auth PC */}
      <div className="hidden md:flex items-center gap-3 mr-4">
        {!user ? (
          <>
            <button className={secondaryBtnStyle} onClick={() => setLoginOpen(true)}>
              Login
            </button>
            <button className={primaryBtnStyle} onClick={() => setRegisterOpen(true)}>
              Sign Up
            </button>
          </>
        ) : (
          <>
            <button className={secondaryBtnStyle} onClick={() => setMyAccountOpen(true)}>
              My Account
            </button>
            {showAccount && (
              <div className="absolute right-0 mt-2 p-2 bg-white shadow-md rounded text-sm z-50">
                <p className="font-semibold">{user.name}</p>
                <p className="text-gray-600">{user.email}</p>
              </div>
            )}
            <button
              // CHANGED: Now uses secondaryBtnStyle instead of dangerBtnStyle
              className={secondaryBtnStyle}
              onClick={() => {
                handleLogout();
                message.success({ content: "Logout successful", duration: 3 });
                navigate("/");
              }}
            >
              Logout
            </button>
          </>
        )}
      </div>

      {/* --- NAVBAR MOBILE --- */}
      <div className="md:hidden px-4">
        <MenuOutlined onClick={() => setOpen(true)} className="text-xl cursor-pointer" />
      </div>

      <Drawer
        title="Menu"
        placement="left"
        onClose={() => setOpen(false)}
        open={open}
      >
        {menuItems}
        <div className="mt-8 flex flex-col gap-3">
          {!user ? (
            <>
              <button className={secondaryBtnStyle} onClick={() => { setLoginOpen(true); setOpen(false); }}>Login</button>
              <button className={primaryBtnStyle} onClick={() => { setRegisterOpen(true); setOpen(false); }}>Sign Up</button>
            </>
          ) : (
            <>
              <button className={secondaryBtnStyle} onClick={() => { setMyAccountOpen(true); setOpen(false); }}>My Account</button>
              <button
                // CHANGED: Now uses secondaryBtnStyle instead of dangerBtnStyle
                className={secondaryBtnStyle}
                onClick={() => {
                  handleLogout();
                  setOpen(false);
                  message.success({ content: "Logout successful", duration: 3 });
                }}
              >
                Logout
              </button>
            </>
          )}
        </div>
      </Drawer>
    </nav>
  );
}